import { useGetPartnerQuery } from '@/api/api.slice.tsx';
import { StepAccountForm } from '@/features/OnBoarding/StepAccount/StepAccountForm.tsx';
import { Loader } from '@arsnovasystems/ars-front-lib';

/**
 * Step Account.
 * Partner is invited to fill its information
 *
 * @returns JSX of the component
 */
export const StepAccount = () => {
  const { data: me } = useGetPartnerQuery();

  if (!me) {
    return <Loader />;
  }

  return <StepAccountForm partner={me} />;
};
